import { render } from "./Uslugi.vue?vue&type=template&id=15319a1c"
import script from "./Uslugi.vue?vue&type=script&lang=js"
export * from "./Uslugi.vue?vue&type=script&lang=js"

import "./Uslugi.sass?vue&type=style&index=0&lang=sass&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__